import { forwardRef, useCallback } from 'react';
import { SimState, SimStates } from '@bymason/controller-api-hooks';
import {
  ControllerSelect,
  Stack,
  Typography,
  ControllerMenuItem,
} from '@bymason-private/legacy-pattern-components';

const ALL_STATUSES = 'all';

interface SimStateSelectorProps {
  onChange: (newValue?: SimState) => void;
  value?: SimState;
}

export default forwardRef(function SimStateSelector({ onChange, value }: SimStateSelectorProps, ref) {
  const handleChange = useCallback(
    (evt) => {
      const newState = evt.target.value;

      onChange(newState !== ALL_STATUSES ? newState : undefined);
    },
    [onChange]
  );

  return (
    <Stack alignItems='center' direction='row' ml={2}>
      <Typography mr={1}>SIM Status:</Typography>
      <ControllerSelect
        onChange={handleChange}
        inputRef={ref}
        value={value || ALL_STATUSES}
        sx={(theme) => ({ backgroundColor: theme.palette.common.white, width: 140, margin: 0 })}
      >
        <ControllerMenuItem key={ALL_STATUSES} value={ALL_STATUSES}>
          All
        </ControllerMenuItem>
        {SimStates.map((s: SimState) => (
          <ControllerMenuItem key={s} value={s}>
            {s}
          </ControllerMenuItem>
        ))}
      </ControllerSelect>
    </Stack>
  );
});
